"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/button/semantics/add-button");
let AttachmentButton = class AttachmentButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.accept = '';
        this.multiple = false;
        this.capture = false;
    }
    render() {
        return (0, lit_1.html) `
      <mm-add-button @click=${this.handleAddButtonClick} label=${this.label}></mm-add-button>
      <input
        type="file"
        accept=${(0, if_defined_js_1.ifDefined)(this.accept || undefined)}
        ?multiple=${this.multiple}
        capture=${this.capture ? 'camera' : lit_1.nothing}
        @change=${this.handleFilesChange}
      />
    `;
    }
    handleAddButtonClick() {
        this.input.click();
    }
    handleFilesChange(event) {
        const input = event.target;
        (0, utils_1.emit)(this, 'change', { files: Array.from(input.files ?? []) });
    }
};
AttachmentButton.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      input {
        ${shared_styles_1.visuallyHiddenStyles};
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AttachmentButton.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AttachmentButton.prototype, "accept", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], AttachmentButton.prototype, "multiple", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], AttachmentButton.prototype, "capture", void 0);
__decorate([
    (0, decorators_js_1.query)('input')
], AttachmentButton.prototype, "input", void 0);
AttachmentButton = __decorate([
    (0, decorators_js_1.customElement)('mm-attachment-button')
], AttachmentButton);
exports.AttachmentButton = AttachmentButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXR0YWNobWVudC1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhdHRhY2htZW50LWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQWtFO0FBQ2xFLGdFQUF3RDtBQUV4RCwrREFBK0U7QUFDL0UsbUNBQThCO0FBQzlCLDJEQUF3RDtBQUdqRCxJQUFNLGdCQUFnQixHQUF0QixNQUFNLGdCQUFpQixTQUFRLGdCQUFVO0lBQXpDOztRQWF1QixVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ1YsV0FBTSxHQUFHLEVBQUUsQ0FBQTtRQUNWLGFBQVEsR0FBRyxLQUFLLENBQUE7UUFDaEIsWUFBTyxHQUFHLEtBQUssQ0FBQTtJQXlCOUMsQ0FBQztJQXRCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs4QkFDZSxJQUFJLENBQUMsb0JBQW9CLFVBQVUsSUFBSSxDQUFDLEtBQUs7OztpQkFHMUQsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxNQUFNLElBQUksU0FBUyxDQUFDO29CQUNoQyxJQUFJLENBQUMsUUFBUTtrQkFDZixJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLGFBQU87a0JBQ2pDLElBQUksQ0FBQyxpQkFBaUI7O0tBRW5DLENBQUE7SUFDSCxDQUFDO0lBRU8sb0JBQW9CO1FBQzFCLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUFFLENBQUE7SUFDcEIsQ0FBQztJQUVPLGlCQUFpQixDQUFDLEtBQVk7UUFDcEMsTUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLE1BQTBCLENBQUE7UUFFOUMsSUFBQSxZQUFJLEVBQUMsSUFBSSxFQUFFLFFBQVEsRUFBRSxFQUFFLEtBQUssRUFBRSxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDLEVBQUUsQ0FBQyxDQUFBO0lBQ2hFLENBQUM7O0FBdkNNLHVCQUFNLEdBQUc7SUFDZCwyQkFBVztJQUNYLElBQUEsU0FBRyxFQUFBOzs7Ozs7VUFNRyxvQ0FBb0I7O0tBRXpCO0NBQ0YsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7K0NBQVc7QUFDVjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7Z0RBQVk7QUFDVjtJQUE1QixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLENBQUM7a0RBQWlCO0FBQ2hCO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQztpREFBZ0I7QUFDNUI7SUFBZixJQUFBLHFCQUFLLEVBQUMsT0FBTyxDQUFDOytDQUFpQztBQWpCckMsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyxzQkFBc0IsQ0FBQztHQUN6QixnQkFBZ0IsQ0F5QzVCO0FBekNZLDRDQUFnQiJ9